export default "__VITE_ASSET__CCGyNgG2__"